import type { SVGProps } from "react";
import { withCustomIcon } from "./withCustomIcon";

const InProgressIcon = (props: SVGProps<SVGSVGElement>) => (
<svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    className="tenera-icon"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor">
      <path
        fill="currentColor"
        d="M15.8784,10.0436c.1009-.1158.1562-.2628.1562-.4147v-2.8925c0-.3538-.2944-.6407-.6576-.6407h-6.6376c-.3632,0-.6577.2869-.6577.6407v2.8925c0,.1519.0554.2989.1563.4147l1.3256,1.5212c.2084.2392.2084.5903,0,.8294l-1.3255,1.5207c-.101.1158-.1564.2628-.1564.4147v2.8918c0,.3539.2944.6407.6577.6407h6.6376c.3632,0,.6576-.2869.6576-.6407v-2.8918c0-.152-.0554-.299-.1563-.4147l-1.3255-1.5207c-.2084-.2391-.2084-.5902,0-.8294l1.3256-1.5212ZM13.7991,13.0513l1.2356,1.4176v2.3933h-5.9528v-2.3933l1.2357-1.4176c.5325-.611.5325-1.5325.0001-2.1435l-1.2358-1.4182v-2.394h5.9528v2.394l-1.2358,1.4182c-.5324.6111-.5323,1.5325.0002,2.1435Z"
        className="primary"
      />
      <path
        fill="currentColor"
        d="M5.7077,9.4321c-.1294-.2441-.4326-.3389-.6763-.2065l-2.2305,1.1863c.7722-4.2795,4.6378-7.511,9.1958-7.511,3.4189,0,6.5615,1.8154,8.2021,4.7373.1338.2412.4385.3267.6807.1914.2402-.1353.3262-.4399.1904-.6807-1.8164-3.2373-5.293-5.248-9.0732-5.248C7.1078,1.9009,2.946,5.2726,1.9143,9.8044l-.9781-1.7458c-.1343-.2407-.4395-.3276-.6802-.1919-.2412.1348-.3271.4395-.1919.6802l1.9214,3.4307,3.5156-1.8691c.2437-.1294.3364-.4321.2065-.6763Z"
        className="primary"
      />
    </g>
    <path
      fill="currentColor"
      d="M23.9362,15.4536l-1.9219-3.4312-3.5146,1.8696c-.2441.1299-.3369.4326-.207.6758.1299.2441.4346.3359.6758.207l2.2298-1.1859c-.7726,4.2791-4.6383,7.5101-9.1951,7.5101-3.4185,0-6.5615-1.8154-8.2021-4.7373-.1353-.2402-.4414-.3271-.6807-.1904-.2412.1348-.3267.4395-.1914.6807,1.8179,3.2363,5.2944,5.2471,9.0742,5.2471,4.8889,0,9.0502-3.3713,10.0826-7.9025l.9774,1.7452c.0918.1641.2617.2559.4365.2559.083,0,.167-.0205.2441-.0635.2412-.1348.3271-.4404.1924-.6807Z"
      className="accent"
    />
  </svg>
);

export default withCustomIcon(InProgressIcon);